import { render, staticRenderFns } from "./roleModal.vue?vue&type=template&id=34d090b2&"
import script from "./roleModal.vue?vue&type=script&lang=js&"
export * from "./roleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports